import React, { useEffect, useState } from 'react'
import { Modal, InputGroup, Form } from 'react-bootstrap';
import { updateTableBd } from '../../config/functions'
import { toast } from 'react-toastify'

const ModalEmpleado24Editar = ({
    show, handleClose, getDetalleEmpleados, empleadoSeleccionado, empleados, setIsLoading, superv
}) => {

    const user = JSON.parse(localStorage.getItem("token")).userName;
    const [empleadoEditar, setEmpleadoEditar] = useState(empleadoSeleccionado.empleado)
    const [cargoEditar, setCargoEditar] = useState(empleadoSeleccionado.cargo)
    const [horarioEditar, setHorarioEditar] = useState(empleadoSeleccionado.horario)
    const [horasEditar, setHorasEditar] = useState(empleadoSeleccionado.horas)

    const [nuevo, setNuevo] = useState(false)

    const horarios = [
        { id: 1, name: '06:00-14:00', horas: 8 },
        { id: 2, name: '14:00-22:00', horas: 8 },
        { id: 3, name: '22:00-06:00', horas: 8 },
        { id: 4, name: '06:00-18:00', horas: 12 },
        { id: 5, name: '18:00-06:00', horas: 12 },
    ]

    //-----------------------------------------------------

    const guardarEditarEmpleado = async () => {

        if (!empleadoEditar.trim()) {
            toast.warning('El nombre no puede estar vacío.');
            return;
        }
        const dataSend = {
            ...empleadoSeleccionado,
            horas: horasEditar,
            horario: horarioEditar,
            empleado: empleadoEditar.toLocaleUpperCase(),
            usuario: user,
        }
        setIsLoading(true)
        try {
            const response = await updateTableBd('updateregistrediarioDE', dataSend)
            if (response) {
                toast.success(`Empleado editado exitosamente`)
                handleClose()
                await getDetalleEmpleados()
            } else {
                toast.error('Error al guardar los datos.');
            }

        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        setHorasEditar(horarios.find(h => h.name === horarioEditar)?.horas || 0)
    }, [horarioEditar])
    //------------------------------------------------------

    return (
        <Modal show={show} onHide={handleClose} size="sm" centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '18px' }}> Opciones de Edición </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <InputGroup className="mb-2" size="sm">
                    <InputGroup.Text id={'empleadoEditar'}>Empleado</InputGroup.Text>
                    {nuevo
                        ? <Form.Control
                            type="text"
                            aria-label={'empleadoEditar'}
                            id={`empleadoNombre`}
                            size="sm"
                            onKeyDown={(e) => {
                                if (e.key === 'escape') {
                                    setNuevo(false)
                                    setEmpleadoEditar(empleadoSeleccionado.empleado)
                                }
                            }}
                            onChange={(e) => setEmpleadoEditar(e.target.value)}
                            value={empleadoEditar} />
                        : <Form.Select
                            aria-label={'empleadoEditar'}
                            id={`empleadoNombre`}
                            size="sm"
                            onChange={(e) => {
                                if (e.target.value === 'nuevo') {
                                    setNuevo(true)
                                    setEmpleadoEditar('')
                                }
                                else setEmpleadoEditar(e.target.value)
                            }}
                            value={empleadoEditar}>
                            {empleados.map(op => (
                                <option key={op.name} value={op.name}>{op.name}</option>
                            ))}
                            <option value="nuevo">Nuevo</option>
                        </Form.Select>
                    }
                </InputGroup>
                <InputGroup className="mb-2" size="sm">
                    <InputGroup.Text id={'cargoEditar'}>Cargo</InputGroup.Text>
                    <Form.Select
                        aria-label={'cargoEditar'}
                        id={`empleadoCargo`}
                        size="sm"
                        disabled
                        onChange={(e) => setCargoEditar(e.target.value)}
                        value={cargoEditar}>
                        <option value={empleadoSeleccionado.cargo}>{empleadoSeleccionado.cargo}</option>
                    </Form.Select>
                </InputGroup>

                {superv && horarios && horarios.length > 0 && (
                    <InputGroup className="mb-2" size="sm">
                        <InputGroup.Text id={'horarioEditar'}>Horario</InputGroup.Text>
                        <Form.Select
                            //className='border-warning'
                            id={'selectHorarioEditar'}
                            aria-label='selectHorarioEditar'
                            size="sm"
                            onChange={(e) => setHorarioEditar(e.target.value)}
                            value={horarioEditar}
                        >   <option value="">Seleccione Horas</option>
                            {horarios.map((op, index) => (
                                <option key={index} value={op.name}>{op.name}</option>
                            ))}
                        </Form.Select>
                    </InputGroup>
                )}

            </Modal.Body>

            <Modal.Footer>
                <button
                    className='btn btn-sm btn-secondary'
                    onClick={handleClose}>
                    Cerrar
                </button>
                <button
                    className='btn btn-primary fa-solid fa-floppy-disk'
                    title='Guardar Cambios'
                    onClick={() => guardarEditarEmpleado()} />
            </Modal.Footer>
        </Modal>
    )
}

export default ModalEmpleado24Editar